import { Box, Typography } from '@mui/material';
import UpdateIcon from '@mui/icons-material/Update';
import moment from 'moment';
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { DATE_FORMAT, EMPTY_VALUE_INDICATOR } from 'framework/utils';

const CreatedAtField = (props: FieldProps) => {
  const { getValue } = useFieldHelper<string>({ source: props.source });
  const value = getValue();

  if (!value) {
    return <Typography variant="body1">{EMPTY_VALUE_INDICATOR}</Typography>;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <UpdateIcon sx={{ color: 'text.secondary', width: 20, height: 20 }} />
      <Typography variant="body1">added {moment(value).format(DATE_FORMAT.FULL_DATE)}</Typography>
    </Box>
  );
};

export default CreatedAtField;
